import axios from '../http'
import {API} from "../const"
import {changeUsername, changeUserOps} from "../../common/bus";

const api = API+'/test/me';


const error = (e) => (m) => console.error(e,m);

export function getUserName(cb, fcb = error('getUserName')) {
    axios.get(api).then(response=> {
        cb(response.data);
    }).catch(err=> {
        fcb(err);
    })
}

export function needChange(cb, fcb = error('needChange')) {
    axios.get(API + '/users/password/needs-changed').then(response=> {
        cb(response.data);
    }).catch(err=> {
        fcb(err);
    })
}

export function getOps(cb, fcb = error('getUserName')) {
    axios.get(API+'/users/me/op').then(response=> {
        cb(response.data);
    }).catch(err=> {
        fcb(err);
    })
}


export function initUserName(){
    getUserName(d=>{
        changeUsername(d)
    })
}

export  function initOps(){
    getOps(ops=>{changeUserOps(ops)})
}
